import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export function setCardKey(key, data) {
  return async (dispatch) => {
    dispatch({type: "SET_CARD_KEY", key, data})
  }
}


export async function importCards(id) {
  try {
    const {data} = await axios.get('/api/card/export-doc?id=' + id);
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}



export function getCards(ids) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_CARD_KEY', key: 'loaded', data: false})
      const {data} = await axios.get('/api/card/get?ids=' + ids.join(','));

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_CARDS', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_CARDS', data: []})
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function getCategoriesUp(id) {
  return async (dispatch) => {
    try {

      const {data} = await axios.get('/api/category-card/get?id=' + id);

      let payload = [];

      if(data.errcode == 200) {
        const cardsCount = data.cardsCount;
        payload = data.payload.map(_i => {
          return {
            ..._i, 
            count: (cardsCount.find(_c => _c.category_id == _i.id) || {cnt: 0}).cnt
          }
        });

        dispatch({type: 'GET_CARD_CATEGORIES', data: payload})
        dispatch(getCategoriesAll())
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function getCategories(id) {
  return async (dispatch) => {
    try {

      dispatch({type: 'SET_CARD_KEY', key: 'categories', data: []})
      dispatch({type: 'SET_CARD_KEY', key: 'category_selcted', data: null})
      dispatch({type: 'SET_CARD_KEY', key: 'selected', data: []})
      dispatch({type: 'SET_CARD_KEY', key: 'list', data: []})

      const {data} = await axios.get('/api/category-card/get?id=' + id);

      let payload = [];

      if(data.errcode == 200) {
        const cardsCount = data.cardsCount;
        payload = data.payload.map(_i => {
          return {
            ..._i, 
            count: (cardsCount.find(_c => _c.category_id == _i.id) || {cnt: 0}).cnt
          }
        });



        dispatch({type: 'GET_CARD_CATEGORIES', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_CARD_CATEGORIES', data: []})
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}


export function getCategoriesAll() {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/category-card/getall');

      if(data.errcode == 200) {
        dispatch({type: 'GET_CARD_CATEGORIES_ALL', data: data.payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_CARD_CATEGORIES', data: []})
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function createCard(body) {
  return async (dispatch, getState) => {
    try {
      dispatch({type: 'SET_CARD_KEY', key: 'loaded', data: false})
      const {data} = await axios.post('/api/card/post', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'ADD_CARD', data: payload});
        const subject_selcted = getState().card.subject_selcted;
        if(subject_selcted && subject_selcted.id){
          dispatch(getCategoriesUp(subject_selcted.id))
        }
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
      
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})      
    }
  }
}

export function createCardCategory(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/category-card/post', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'ADD_CARD_CATEGORY', data: payload});
        dispatch(getCategoriesAll())
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
      
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})      
    }
  }
}
export function deleteCard(id) {
  return async (dispatch, getState) => {
    try {
      dispatch({type: 'SET_CARD_KEY', key: 'loaded', data: false})
      const {data} = await axios.post('/api/card/delete', { id });

      if(data.errcode == 200) {
        dispatch({type: 'DELETE_CARD', data: id});
        dispatch(getTrashedCount());
        const subject_selcted = getState().card.subject_selcted;
        if(subject_selcted && subject_selcted.id){
          dispatch(getCategoriesUp(subject_selcted.id))
        }
        return data.payload;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
     
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
    }
  }
}
export function deleteCardCategory(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/category-card/delete', { id });

      if(data.errcode == 200) {
        dispatch({type: 'DELETE_CARD_CATEGORY', data: id});
        dispatch(getTrashedCount());
        dispatch(getCategoriesAll())
        return data.payload;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
     
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
    }
  }
}


export function updateCard(body) {
  return async (dispatch, getState) => {
    try {
      const selected_categories = getState().card.selected || [];
      dispatch({type: 'SET_CARD_KEY', key: 'loaded', data: false})
      const {data} = await axios.post('/api/card/patch', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        if(selected_categories.map(_i => parseInt(_i)).indexOf(parseInt(body.category_id)) > -1){
          dispatch({type: 'UPDATE_CARD', data: payload});
        } else {
          dispatch({type: 'DELETE_CARD', data: body.id});
        }
        const subject_selcted = getState().card.subject_selcted;
        if(subject_selcted && subject_selcted.id){
          dispatch(getCategoriesUp(subject_selcted.id))
        }
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'}) 
    }
  }
}

export function getTrashedCount() {
  return async (dispatch) => {
    try {
      
      const {data} = await axios.get('/api/card/trashedcount');

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'SET_CARD_KEY', key: 'trashed_count', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'}) 
    }
  }
}
export function updateCardCategory(body) {
  return async (dispatch) => {
    try {
      
      const {data} = await axios.post('/api/category-card/patch', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'UPDATE_CARD_CATEGORY', data: payload});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'}) 
    }
  }
}


export function setCardCategoryItem(data) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_CARD_KEY', key: 'category_selcted', data})
      return data;
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}



export function getSubjects() {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/subject-card/get');

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_CARD_SUBJECTS', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_CARD_SUBJECTS', data: []})
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function createCardSubject(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/subject-card/post', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'ADD_CARD_SUBJECT', data: payload});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
      
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})      
    }
  }
}
export function deleteCardSubject(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/subject-card/delete', { id });

      if(data.errcode == 200) {
        dispatch({type: 'DELETE_CARD_SUBJECT', data: id});
        dispatch(getTrashedCount());
        return data.payload;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
     
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
    }
  }
}


export function updateCardSubject(body) {
  return async (dispatch) => {
    try {
      
      const {data} = await axios.post('/api/subject-card/patch', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'UPDATE_CARD_SUBJECT', data: payload});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'}) 
    }
  }
}


export function setCardSubjectItem(data) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_CARD_KEY', key: 'subject_selcted', data})
      return data;
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}

export function getRoomStudents(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/room/students', {id});

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_ROOM_STUDENTS', data: payload});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}

export function addRoomStudents(body) {
  console.log("TCL: addRoomStudents -> body", body)
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/room/add-students', {
        room_id: body.room_id,
        ids: body.students.map(item => item.id),
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'ADD_ROOM_STUDENTS', data: body.students});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}

export async function sendInvite(body) {
  const {data} = await axios.post('/api/room/send-invite', body);
  if(data.errcode == 200) {
    return true
  } else {
    throw new Error('Not send');
  } 
}

export function deleteRoomStudent(body) {
  console.log("TCL: addRoomStudents -> body", body)
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/room/delete-student', body);

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'DELETE_ROOM_STUDENT', data: body.student_id});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}

export function setCartItemCopy(body) {
  console.log("TCL: addRoomStudents -> body", body)
  return async (dispatch) => {
    dispatch({type: 'SET_CARD_ITEM_COPY', data: body});
  }
}

export async function searchStudents(body) {
  try {
    const {data} = await axios.post('/api/room/search-students', body);

    let payload = [];

    if(data.errcode == 200) {
      payload = data.payload;
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    console.log("TCL: getRooms -> error", error)
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Card/actions.js